module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "o-icon",
    attrs: {
      "width": "24",
      "height": "24",
      "focusable": "false",
      "role": _vm.role,
      "aria-label": _vm.label
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": (_vm.baseUrl + "img/icons.svg#icon-" + _vm.name)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5167b790","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Icon.vue
// module id = 63
// module chunks = 0